<template>
  <ToggleSection
    v-if="dv.ownershipLifecycleGrid?.length > 0"
    label="Ownership and Lifecycle"
    icon-classes="fa-solid fa-arrows-spin"
    :collapsed="collapsed || !dv.isEditing"
  >
    <FieldGrid :fields="dv.ownershipLifecycleGrid" :dv="dv" />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'EntityOwnership',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
    collapsed: { type: Boolean, default: true },
  },
}
</script>
